import { Controller } from "@hotwired/stimulus"

// Auto-detects the browser's timezone and sets a hidden field value.
// Usage: data-controller="timezone" on the form,
//        data-timezone-target="field" on the hidden input.
export default class extends Controller {
  static targets = ["field"]

  connect() {
    if (this.hasFieldTarget) {
      this.fieldTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  }
}
